
export function formatDate(dateString) {
  if (!dateString) return "-";

  // Nos quedamos solo con la parte de fecha (por si viene con hora)
  const cleanDate = dateString.split("T")[0];

  // Esperamos YYYY-MM-DD
  const [year, month, day] = cleanDate.split("-");
  if (!year || !month || !day) return "-";

  return `${day}/${month}/${year}`;
}

export const formatCOPInput = (value) => {
  if (!value) return "";

  const number = value.toString().replace(/\D/g, "");

  return new Intl.NumberFormat("es-CO").format(number);
};


// Limpia todo excepto números
export const cleanNumber = (value = "") =>
  value.replace(/\D/g, "");

// Agrega puntos de miles (visual)
export const formatNumberWithDots = (value = "") => {
  if (!value) return "";
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

// COP para tablas / totales
export function formatCurrencyCOP(value) {
  return `$${Number(value || 0).toLocaleString("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}

export function formatDateTime(dateString) {
  if (!dateString) return "-";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "-";

  return date.toLocaleString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}